module.exports = __webpack_public_path__ + "assets/hr-eec3ff06f46364f02785914655862180.svg";